module.exports = __webpack_public_path__ + "static/media/sound1.a2537626.mp3";